import type { Communication } from '@medplum/fhirtypes';
import { useLocation } from 'react-router-dom';
import { MessagingPage } from '../messaging';
import { ClientPortalLayout } from './components/ClientPortalLayout';

/** Navigation state shape set by RequestAppointmentModal */
export interface MessagesNavState {
  preloadThread?: Communication;
  preloadMessages?: Communication[];
  selectThreadId?: string;
}

export function ClientPortalMessagesPage(): JSX.Element {
  const location = useLocation();
  const state = (location.state ?? {}) as MessagesNavState;

  const extraThreads = state.preloadThread ? [state.preloadThread] : undefined;

  return (
    <ClientPortalLayout title="Messages" localhostOnly fullBleed>
      <MessagingPage
        inboxSections={['providers']}
        composeRecipientTypes={['provider']}
        extraThreads={extraThreads}
        initialThreadId={state.selectThreadId}
        initialMessages={state.preloadMessages}
      />
    </ClientPortalLayout>
  );
}
